import React from 'react'
import { TiArrowBack } from "react-icons/ti";
import { useNavigate } from "react-router-dom";



function TopBack({ label }) {

    const navigate = useNavigate();

    return (
        <div
            className="back-container"
            onClick={() => navigate(-1)}
        >
            <TiArrowBack size={20} />
            <span>{label}</span>
        </div>
    )
}

export default TopBack